export const TermDTO = {
    list: (raw) => ({
        publicId: raw.publicId,
        name: raw.name,
        code: raw.code,
        startDate: raw.startDate,
        endDate: raw.endDate,
        isActive: raw.isActive,
        isDefault: raw.isDefault,
        enrollmentCount: raw.enrollmentCount ?? 0,
        type: raw.type ?? 'PHYSICAL',
        isApplicationOpen: !!raw.isApplicationOpen,
    }),

    detail: (raw) => ({
        publicId: raw.publicId,
        name: raw.name,
        code: raw.code,
        startDate: raw.startDate,
        endDate: raw.endDate,
        enrollmentLimit: raw.enrollmentLimit ?? null,
        enrollmentCount: raw.enrollmentCount ?? 0,
        isDefault: raw.isDefault ?? false,
        isActive: raw.isActive ?? false,
        note: raw.note ?? '',
        type: raw.type ?? 'PHYSICAL',
        isApplicationOpen: !!raw.isApplicationOpen,
    }),

    active: (raw) => ({
        publicId: raw.publicId,
        name: raw.name,
        startDate: raw.startDate,
        endDate: raw.endDate,
        enrollmentLimit: raw.enrollmentLimit,
        enrollmentCount: raw.enrollmentCount,
        remainingSlots: raw.remainingSlots,
    }),
};
